// getData

export const GETDATAREQUEST="GETDATAREQUEST"
export const GETDATASUCESSFUL="GETDATASUCESSFUL"
export const GETDATAFAIL="GETDATAFAIL"
// delete
// export const GETDATAREQUEST="GETDATAREQUEST"
// export const GETDATASUCESSFUL="GETDATASUCESSFUL"
// export const GETDATAFAIL="GETDATAFAIL"
// //update
// export const GETDATAREQUEST="GETDATAREQUEST"
// export const GETDATASUCESSFUL="GETDATASUCESSFUL"
// export const GETDATAFAIL="GETDATAFAIL"